import { configureStore, combineReducers } from "@reduxjs/toolkit";

import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import config from "./app.slice";
import admin from "@/views/admin-dashboard/admin.slice";
import announcements from "@/views/build-your-solution/build-your-solution.slice";
import detail from "@/common/components/announcement-detail/detail.slice";

import visura from "@/views/admin-dashboard/visura-to-excel/visura.slice";

const persistConfig = {
  key: "main-root",
  storage,
};

const rootReducer = combineReducers({
  config,
  admin,
  announcements,
  detail,
  visura,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),

  devTools: {
    actionsDenylist: "setProps",
  },
});

const Persistor = persistStore(store);

export { Persistor, store };
